export interface CheckoutCompletedQuoteConfirmation {
  breakdownStartDate: string;
  bundlePlanNumbers?: string[];
  digitalId?: string;
  planNumber: string;
  renewalDate: string;
}
